import { UserSelectedTransactionListEvent } from '@/common/bot/types/events/external/external-events';
import type { ConnectPages, ConnectWizardEvent, ConnectWizardEvents } from './enum.support-wizard';

export interface VisitorInformation {
  displayName: string;
  email: string;
  name?: string;
  phone?: string;
  isGuest?: boolean;
}

export interface DynamicFieldData {
  fields: { key: string; value: string; id: number }[];
}
/**
 * The event when visitor has filled the information. The visitor can be
 * a guest or a logged in user.
 */

export interface VisitorInfoFilled {
  visitorInfo?: VisitorInformation;
  description: string;
}

export enum ConnectRequestType {
  CHAT = 'chat',
  OPEN_REQUEST = 'openRequest',
  /** Twilio agent voice (connect wizard). */
  VOICE = 'voice',
  /** Landing Voice AI — handled outside the Twilio connect wizard. */
  VOICE_AI = 'voiceAi',
  FOLLOW_UP = 'followUp',
}

export interface ConnectRequestEvent {
  type: ConnectRequestType;
  payload: {
    ticketId?: number;
    description?: string;
    /**
     * Adding a comment is not a part of connect request.
     * @deprecated
     */
    comment?: string;
    meta?: TransactionMetaData[];
    confirmation?: boolean;
  };
}
/**
 * A form field. More props can be added as needed.
 */

export interface FormField {
  id: number;
  displayName: string;
  placeholder: string;
  name: string;
  required?: boolean;
}

export interface TransactionMetaData {
  extraFieldKey: string;
  extraFieldValue: unknown;
}
/**
 * The event when the user has selected a transaction.
 */

export interface TransactionInput {
  type: string;
  none: boolean;
  empty: boolean;
  issues: string[];
  meta: TransactionMetaData[];
}

export interface ConfirmConnectSupportRequestPayload {
  requestType: ConnectRequestType;
}

export interface BaseConnectWizardEvent {
  type: ConnectWizardEvents;
  payload?: unknown;
}
export interface TransactionInputEvent extends BaseConnectWizardEvent {
  type: typeof ConnectWizardEvent.transactionSelected;
  payload: UserSelectedTransactionListEvent['payload'];
}
export interface VisitorInfoSubmittedEvent extends BaseConnectWizardEvent {
  type: typeof ConnectWizardEvent.guestInfoFilled;
  page: ConnectPages;
  payload: VisitorInfoFilled;
}
export interface DescriptionSubmittedEvent extends BaseConnectWizardEvent {
  type: typeof ConnectWizardEvent.descriptionSubmitted;
  payload: VisitorInfoFilled;
}

export interface OpenRequestSelectedEvent extends BaseConnectWizardEvent {
  type: typeof ConnectWizardEvent.openRequestSelected;
  payload: unknown;
}
export interface ConnectToSupportEvent extends BaseConnectWizardEvent {
  type: typeof ConnectWizardEvent.connectRequest;
  payload: ConnectRequestEvent;
}

export interface ConfirmConnectSupportRequestEvent extends BaseConnectWizardEvent {
  type: typeof ConnectWizardEvent.confirmConnectSupportRequest;
  payload: ConfirmConnectSupportRequestPayload;
}
